export const searchMethod = ({ options, term }) => {
  return options.filter(option =>
    option.label.toString().toLowerCase().includes(term.toLowerCase()),
  );
};
